import instance, { ApiResponse } from '../../api';
import { AxiosResponse } from 'axios';
import { BaseApi } from '../../baseApi';
import { setUpListEndpoint } from './listTableHelpers';
export class InfoTableApi extends BaseApi {
  public static getInfoTableList = async (
    listUrl: string,
    newParams?: any
  ): Promise<any> => {
    const urlWithParams: string = setUpListEndpoint(listUrl, newParams);

    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        urlWithParams
      );
      if (InfoTableApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return InfoTableApi.successResponse(data);
      }
    } catch (error: any) {
      if (error.response) {
        const errors = error.response.data.errors;

        if (errors) {
          return InfoTableApi.errorResponse(errors);
        }
      }
    }
  };
}
